export default {
    SET_BRANDS: (state, brands) => {
        state.brands = brands;
    },

    SET_ESTABLISHMENTS: (state, establishments) => {
        state.establishments = establishments;
    },

    SET_OPERATORS: (state, operators) => {
        state.operators = operators;
    },

    SET_OPTION_CLASSES: (state, optionClasses) => {
        state.optionClasses = optionClasses;
    },

    SET_COMPANIES: (state, companies) => {
        state.companies = companies;
    },

    SET_CONFLEVELS: (state, levels) => {
        state.deliveryConfidenceLevels = levels;
    },

    CLEAR_BRAND_OPTIONS: (state) => {
        state.brandOptions = Object.assign(...Object.keys(state.brandOptions).map(brand => ({
            [brand]: {
                tariffs: state.brandOptions[brand].tariffs,
                options: state.brandOptions[brand].options.map(it => Object.assign({}, it, { checked: false })),
            },
        })));
    },

    SET_BRAND_OPTIONS: (state, brandOptions) => {
        state.brandOptions = brandOptions;
    },

    SET_DRIVER_COMMISSIONS: (state, driverCommissions) => {
        state.driverCommissions = driverCommissions;
    },

    SET_DRIVER_COMMISSION_SYSTEMS: (state, driverCommissionSystems) => {
        state.driverCommissionSystems = driverCommissionSystems;
    },

    SET_DISTRICS: (state, districts) => {
        state.districts = districts;
    },

    SET_DRAWER: (state, drawer) => {
        state.drawer = drawer;
    },

    SET_PAYMENT_TYPES: (state, paymentTypes) => {
        state.paymentTypes = paymentTypes;
    },

    SET_CURRENT_BRANCH: (state, branch) => {
        state.currentBranch = branch;
    }
};
